import { normalizeTimeValue } from "./flightTimingUtils";

const DELETED_CHANGE_STATUS = "DELETED";

function toFlightArray(flights) {
    if (!flights) {
        return [];
    }
    if (flights instanceof Map) {
        return Array.from(flights.values());
    }
    if (Array.isArray(flights)) {
        return flights;
    }
    if (typeof flights === "object") {
        return Object.values(flights);
    }
    return [];
}

function isDeletedFlight(flight) {
    return flight?.is_deleted || String(flight?.change_status || "").toUpperCase() === DELETED_CHANGE_STATUS;
}

function sameValue(left, right) {
    return String(left ?? "") === String(right ?? "");
}

export function buildWorkingFlightSnapshot(flight, overrides = {}) {
    const workingFlight = {
        ...(flight || {}),
        ...(overrides || {}),
    };

    return {
        id: workingFlight.id ?? workingFlight.flight_id,
        track_id: workingFlight.track_id,
        aircraft_reg: workingFlight.aircraft_reg,
        flight_number: workingFlight.flight_number,
        departure_airport: workingFlight.departure_airport,
        arrival_airport: workingFlight.arrival_airport,
        std: normalizeTimeValue(workingFlight.std),
        sta: normalizeTimeValue(workingFlight.sta),
        flight_date: workingFlight.flight_date,
        day_of_week: workingFlight.day_of_week,
        block_time_minutes: workingFlight.block_time_minutes,
        min_block_time_minutes: workingFlight.min_block_time_minutes,
        ground_time_minutes: workingFlight.ground_time_minutes,
        min_ground_time_minutes: workingFlight.min_ground_time_minutes,
        aircraft_type: workingFlight.aircraft_type,
        rotation_no: workingFlight.rotation_no,
        rotation_leg_index: workingFlight.rotation_leg_index,
        rotation_index: workingFlight.rotation_index,
        flight_route_id: workingFlight.flight_route_id,
        display_order: workingFlight.display_order,
        is_fixed: workingFlight.is_fixed,
        remarks: workingFlight.remarks,
        route_snapshot: workingFlight.route_snapshot,
        origin_v1_flight_id: workingFlight.origin_v1_flight_id,
        origin_track_id: workingFlight.origin_track_id,
        change_status: workingFlight.change_status,
        change_source: workingFlight.change_source,
    };
}

export function buildTrackWorkingFlightsSnapshot(flights, trackId, overridesByFlightId = null) {
    return toFlightArray(flights)
        .filter((flight) => sameValue(flight?.track_id, trackId))
        .filter((flight) => !isDeletedFlight(flight))
        .map((flight) => buildWorkingFlightSnapshot(flight, overridesByFlightId?.get(String(flight.id))));
}

export function buildAircraftWorkingFlightsSnapshot(flights, aircraftReg, trackId, overridesByFlightId = null) {
    return buildTrackWorkingFlightsSnapshot(flights, trackId, overridesByFlightId)
        .filter((flight) => sameValue(flight?.aircraft_reg, aircraftReg));
}

export default buildTrackWorkingFlightsSnapshot;
